import { defineAsyncComponent } from 'vue'
export default {
  checkout: defineAsyncComponent(() => import("/builds/shop22/kik-storefront-monorepo/storefront/layouts/checkout.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/builds/shop22/kik-storefront-monorepo/storefront/layouts/default.vue").then(m => m.default || m)),
  magnolia: defineAsyncComponent(() => import("/builds/shop22/kik-storefront-monorepo/storefront/layouts/magnolia.vue").then(m => m.default || m))
}